<template>
  <div>
    <!-- 新增 -->
    <el-dialog :title="$t('message.add')" :visible.sync="dialogVisible" width="700px" center
      :close-on-click-modal="false">
      <div class="content">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
          <el-form-item label="客户ID：" prop="user_id">
            <el-input v-model="ruleForm.user_id" @blur="getUser"></el-input>
          </el-form-item>
          <el-form-item label="客户名：">
            <div class="row">
              <div class="item">
                {{ userDetail.realname }}
              </div>
              <div class="item">
                <div class="key"> 账户余额：</div>
                <div class="value">{{ userDetail.balance }}円</div>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="出金金額：" prop="client_amount">
            <el-input v-model="ruleForm.client_amount" type="number" @input="maxNum"
              style="width: 200px;margin-right: 20px;"></el-input>円
          </el-form-item>
          <el-form-item label="銀行名：" prop="client_bank_name">
            <el-input v-model="ruleForm.client_bank_name"></el-input>
          </el-form-item>
          <el-form-item label="支店番号：" prop="client_bank_branch_name">
            <el-input v-model="ruleForm.client_bank_branch_name"></el-input>
          </el-form-item>
          <el-form-item label="支店名：" prop="client_bank_branch_no">
            <el-input v-model="ruleForm.client_bank_branch_no"></el-input>
          </el-form-item>
          <el-form-item label="預金種目：" prop="client_pay_type">
            <el-input v-model="ruleForm.client_pay_type"></el-input>
          </el-form-item>
          <el-form-item label="口座番号：" prop="client_account">
            <el-input v-model="ruleForm.client_account"></el-input>
          </el-form-item>
          <el-form-item label="口座名義：" prop="client_bank_username">
            <el-input v-model="ruleForm.client_bank_username"></el-input>
          </el-form-item>
          <el-form-item label="出金申請原因：" prop="client_reason">
            <el-input v-model="ruleForm.client_reason" type="textarea"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="balanceExtract" style="width:300px">提现登记</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {

    return {
      dialogVisible: false,
      ruleForm: {
        user_id: '',
      },
      userDetail: {},
      rules: {
        user_id: [
          {
            required: true,
            message: "请输入客户ID",
            trigger: ["blur", "change"],
          },
        ],
        client_amount: [
          {
            required: true,
            message: "请输入出金金額",
            trigger: ["blur", "change"],
          },
        ],
        client_bank_name: [
          {
            required: true,
            message: "请输入銀行名",
            trigger: ["blur", "change"],
          },
        ],
        client_bank_branch_no: [
          {
            required: true,
            message: "请输入支店番号",
            trigger: ["blur", "change"],
          },
        ],
        client_bank_branch_name: [
          {
            required: true,
            message: "请输入支店名",
            trigger: ["blur", "change"],
          },
        ],
        client_pay_type: [
          {
            required: true,
            message: "请输入預金種目",
            trigger: ["blur", "change"],
          },
        ],
        client_account: [
          {
            required: true,
            message: "请输入口座番号",
            trigger: ["blur", "change"],
          },
        ],
        client_bank_username: [
          {
            required: true,
            message: "请输入口座名義",
            trigger: ["blur", "change"],
          },
        ],
        client_reason: [
          {
            required: true,
            message: "请输入出金申請原因",
            trigger: ["blur", "change"],
          },
        ],


      },

    };
  },
  methods: {
    //获取客户信息
    getUser() {
      if (this.ruleForm.user_id) {
        this.$api.clienteleApi.clientList({ id: this.ruleForm.user_id }).then((res) => {
          if (res.data.total > 0) {
            this.userDetail = res.data.data[0]
          }

        })
      }
    },
    // 最大值
    maxNum() {
      if (this.userDetail.balance && this.userDetail.balance < this.ruleForm.client_amount) {
        this.ruleForm.client_amount =
          this.userDetail.balance
      }
    },
    balanceExtract() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.$api.financialApi.balanceExtract(this.ruleForm).then(res => {
            this.dialogVisible = false
            this.$parent.cashList()
          })
        }
      })
    }
  },
  watch: {
    dialogVisible() {
      this.ruleForm = {}
      this.userDetail = {}
    }
  }
}
</script>
<style lang='scss' scoped>
.content {
  padding: 0 50px;

  /deep/.el-form-item {


    .el-form-item__content {
      display: flex;
    }
  }

  /deep/.el-form-item__label {
    margin: 0;
    padding: 0;
  }

  .row {
    display: flex;
    width: 100%;

    .item {
      flex: 1;
      display: flex;
    }
  }
}
</style>